export default __webpack_public_path__ + "static/media/assemble_large.089b3fdb.png";